import { Routes } from "@angular/router";

import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { AuthLayoutComponent } from "./layouts/auth/auth-layout.component";
import { LoginComponent } from "./authentication/login/login.component";
import { AuthGuard } from "./authentication/authGuard.service";
import { UpdatePasswordComponent } from "./authentication/update-password/update-password.component";

export const AppRoutes: Routes = [
  {
    path: "",
    canActivateChild: [AuthGuard],
    component: AdminLayoutComponent,
    children: [
      {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full"
      },
      {
        path: "admissions",
        loadChildren: "./admissions/admissions.module#AdmissionsModule"
      },
      {
        path: "dashboard",
        loadChildren: "./dashboard/dashboard.module#DashboardModule"
      },
      {
        path: "patients",
        loadChildren: "./patients/patients.module#PatientsModule"
      },
      {
        path: "consultations",
        loadChildren: "./consultation/consultation.module#ConsultationModule"
      },
      {
        path: "prescriptions",
        loadChildren:
          "./laboratoire/prescription/prescription.module#PrescriptionModule"
      },
      {
        path: "analyses",
        loadChildren: "./laboratoire/analyse/analyse.module#AnalyseModule"
      },
      {
        path: "parametrage/profession",
        loadChildren:
          "./parametrage/profession/profession.module#ProfessionModule"
      },
      {
        path: "parametrage/liens",
        loadChildren:
          "./parametrage/lien-parental/lien-parental.module#LienParentalModule"
      },
      {
        path: "parametrage/typeAdmission",
        loadChildren:
          "./parametrage/type-admission/type-admission.module#TypeAdmissionModule"
      },
      {
        path: "parametrage/grades",
        loadChildren:
          "./parametrage/grade/grade.module#GradeModule"
      },
      {
        path: "parametrage/corps",
        loadChildren:
          "./parametrage/corps/corps.module#CorpsModule"
      },
      {
        path: "catalogues",
        loadChildren: "./laboratoire/catalogue/catalogue.module#CatalogueModule"
      },
      {
        path: "dialyse",
        loadChildren:
          "./planning-dialyse/planning-dialyse.module#PlanningDialyseModule"
      },
      {
        path: "programmation-lots",
        loadChildren:
          "./planning-dialyse/planning-dialyse.module#PlanningDialyseModule"
      },
      {
        path: "categories",
        loadChildren: "./imagerie/categorie/categorie.module#CategorieModule"
      },
      {
        path: "examens",
        loadChildren: "./imagerie/examen/examen.module#ExamenModule"
      },
      {
        path: "patientsimagerie",
        loadChildren:
          "./imagerie/patient/patient-imagerie.module#PatientImagerieModule"
      },
      {
        path: "widget",
        loadChildren: "./widget/widget.module#WidgetModule"
      },
      {
        path: "basic",
        loadChildren: "./components/basic/basic.module#BasicModule"
      },
      {
        path: "advance",
        loadChildren: "./components/advance/advance.module#AdvanceModule"
      },
      {
        path: "animations",
        loadChildren: "./animations/animations.module#AnimationsModule"
      },
      {
        path: "forms",
        loadChildren: "./components/forms/forms.module#FormsModule"
      },
      {
        path: "bootstrap-table",
        loadChildren:
          "./components/tables/bootstrap-table/bootstrap-table.module#BootstrapTableModule"
      },
      {
        path: "data-table",
        loadChildren:
          "./components/tables/data-table/data-table.module#DataTableModule"
      },
      {
        path: "map",
        loadChildren: "./map/map.module#MapModule"
      },
      {
        path: "charts",
        loadChildren: "./charts/charts.module#ChartsModule"
      },
      {
        path: "maintenance/error",
        loadChildren: "./maintenance/error/error.module#ErrorModule"
      },
      {
        path: "maintenance/coming-soon",
        loadChildren:
          "./maintenance/coming-soon/coming-soon.module#ComingSoonModule"
      },
      {
        path: "user",
        loadChildren: "./user/user.module#UserModule"
      },
      {
        path: "crm-contact",
        loadChildren:
          "./components/crm-contact/crm-contact.module#CrmContactModule"
      },
      {
        path: "task",
        loadChildren: "./components/task/task.module#TaskModule"
      },
      {
        path: "editor",
        loadChildren: "./components/editor/editor.module#EditorModule"
      },
      {
        path: "invoice",
        loadChildren: "./components/invoice/invoice.module#InvoiceModule"
      },
      {
        path: "file-upload",
        loadChildren:
          "./components/file-upload/file-upload.module#FileUploadModule"
      },
      {
        path: "change-log",
        loadChildren: "./change-log/change-log.module#ChangeLogModule"
      },
      {
        path: "simple-page",
        loadChildren: "./simple-page/simple-page.module#SimplePageModule"
      },
      {
        path: "parametrage",
        loadChildren: "./parametrage/parametrage.module#ParametrageModule"
      },
      {
        path: "parametrage/consultationCategorie",
        loadChildren:
          "./parametrage/consultation/consultation-categorie/consultation-categorie.module#ConsultationCategorieModule"
      },
      {
        path: "parametrage/paramdialyse",
        loadChildren:
          "./parametrage/parametrage-dialyse/parametrage-dialyse.module#ParametrageDialyseModule"
      },
      {
        path: "pharmacie",
        loadChildren:
          "./pharmacie/medicament/medicament.module#MedicamentModule"
      },
      {
        path: "ephemeride",
        loadChildren:
          "./ephemeride/ephemeride/ephemeride.module#EphemerideModule"
      },
      {
        path: "pharmacie/fournisseurs",
        loadChildren:
          "./pharmacie/fournisseur/fournisseur.module#FournisseurModule"
      },
      {
        path: "pharmacie/stock",
        loadChildren: "./pharmacie/stock/stock.module#StockModule"
      },
      {
        path: "pharmacie/commandes",
        loadChildren: "./pharmacie/commande/commande.module#CommandeModule"
      },
      {
        path: "parametrage/pharmacie",
        loadChildren:
          "./parametrage/pharmacie/conditionnement/conditionnement.module#ConditionnementModule"
      },
      {
        path: "parametrage/unite",
        loadChildren: "./parametrage/pharmacie/unite/unite.module#UniteModule"
      },
      {
        path: "parametrage/famille",
        loadChildren:
          "./parametrage/pharmacie/famille/famille.module#FamilleModule"
      },

      {
        path: "parametrage/voie_dabord",
        loadChildren:
          "./parametrage/voie_dabord/voiedabord-catheter/voiedabord-catheter.module#VoiedabordCatheterModule"
      },
      {
        path: "parametrage/fav",
        loadChildren:
          "./parametrage/voie_dabord/voie-dabord-fav/voie-dabord-fav.module#VoieDabordFavModule"
      },
      {
        path: "parametrage/localisation",
        loadChildren:
          "./parametrage/voie_dabord/voie-dabord-localisation/voie-dabord-localisation.module#VoieDabordLocalisationModule"
      },
      {
        path: "parametrage/ponctionligne",
        loadChildren:
          "./parametrage/voie_dabord/voie-dabord-ponction-ligne/voie-dabord-ponction-ligne.module#VoieDabordPonctionLigneModule"
      },
      {
        path: "parametrage/ponction",
        loadChildren:
          "./parametrage/voie_dabord/voie-dabord-ponction/voie-dabord-ponction.module#VoieDabordPonctionModule"
      },
      {
        path: "parametrage/prothese",
        loadChildren:
          "./parametrage/voie_dabord/voie-dabord-prothese/voie-dabord-prothese.module#VoieDabordProtheseModule"
      },
      {
        path: "parametrage/typeanesthesie",
        loadChildren:
          "./parametrage/voie_dabord/voie-dabord-type-anesthesie/voie-dabord-type-anesthesie.module#VoieDabordTypeAnesthesieModule"
      },
      {
        path: "parametrage/type",
        loadChildren:
          "./parametrage/voie_dabord/voie-dabord-type/voie-dabord-type.module#VoieDabordTypeModule"
      },
      {
        path: "parametrage/aiguille",
        loadChildren:
          "./parametrage/voie_dabord/aiguille/aiguille.module#AiguilleModule"
      },

      {
        path: "parametrage/dialyseur",
        loadChildren:
          "./parametrage/dialyse/dialyseur/dialyseur.module#DialyseurModule"
      },

      {
        path: "parametrage/dialysat",
        loadChildren:
          "./parametrage/dialyse/dialysat/dialysat.module#DialysatModule"
      },
      {
        path: "parametrage/poste",
        loadChildren:
          "./parametrage/dialyse/poste/poste.module#PosteModule"
      },
      {
        path: "parametrage/anticoagulant",
        loadChildren:
          "./parametrage/dialyse/anticoagulant/anticoagulant.module#AnticoagulantModule"
      },

      {
        path: "parametrage/familleacte",
        loadChildren:
          "./parametrage/dialyse/familleacte/familleacte.module#FamilleacteModule"
      },

      {
        path: "parametrage/prescription_dialyse",
        loadChildren:
          "./parametrage/prescription_dialyse/profil-na/profil-na.module#ProfilNaModule"
      },
      {
        path: "parametrage/generateur",
        loadChildren:
          "./parametrage/prescription_dialyse/seance-generateur/seance-generateur.module#SeanceGenerateurModule"
      },

      {
        path: "parametrage/model",
        loadChildren:
          "./parametrage/prescription_dialyse/seance-model/seance-model.module#SeanceModelModule"
      },
      {
        path: "parametrage/sol",
        loadChildren:
          "./parametrage/prescription_dialyse/seance-sol-restitution/seance-sol-restitution.module#SeanceSolRestitutionModule"
      },
      {
        path: "parametrage/typetraitemenent",
        loadChildren:
          "./parametrage/prescription_dialyse/seance-type-traitement/seance-type-traitement.module#SeanceTypeTraitementModule"
      },
      {
        path: "parametrage/prescription_dialyse_type",
        loadChildren:
          "./parametrage/prescription-dialyse-type/type-admission/type-admission.module#TypeAdmissionModule"
      },
      {
        path: "parametrage/patient",
        loadChildren:
          "./parametrage/prescription-dialyse-type/type-patient/type-patient.module#TypePatientModule"
      },
      {
        path: "parametrage/radio",
        loadChildren:
          "./parametrage/prescription-dialyse-type/type-radiographie/type-radiographie.module#TypeRadiographieModule"
      },

      {
        path: "parametrage/antecedent",
        loadChildren:
          "./parametrage/antecedent/antecedent-categorie/antecedent-categorie.module#AntecedentCategorieModule"
      },

      {
        path: "parametrage/typeantecedent",
        loadChildren:
          "./parametrage/antecedent/antecedent-type/antecedent-type.module#AntecedentTypeModule"
      },
      {
        path: "parametrage/parampersonnel",
        loadChildren:
          "./parametrage/parametrage-personnel/parametrage-personnel.module#ParametragePersonnelModule"
      },
      {
        path: "parametrage/specialite",
        loadChildren:
          "./parametrage/parametrage-personnel/specialite/specialite.module#SpecialiteModule"
      },
      {
        path: "parametrage/service",
        loadChildren:
          "./parametrage/parametrage-personnel/service/service.module#ServiceModule"
      },
      {
        path: "parametrage/centre",
        loadChildren:
          "./parametrage/parametrage-personnel/centre/centre.module#CentreModule"
      },
      {
        path: "parametrage/consultationMaladie",
        loadChildren:
          "./parametrage/consultation/consultation-maladie/consultation-maladie.module#ConsultationMaladieModule"
      },
      {
        path: "parametrage/maladie",
        loadChildren:
          "./parametrage/consultation/maladie/maladie.module#MaladieModule"
      },
      {
        path: "parametrage/zones",
        loadChildren: "./parametrage/zones/zones/zones.module#ZonesModule"
      },
      {
        path: "parametrage/matrimoniale",
        loadChildren:
          "./parametrage/matrimoniale/matrimoniale/matrimoniale.module#MatrimonialeModule"
      },
      {
        path: "parametrage/langue",
        loadChildren:
          "./parametrage/matrimoniale/langue/langue.module#LangueModule"
      },
      {
        path: "parametrage/pays",
        loadChildren: "./parametrage/matrimoniale/pays/pays.module#PaysModule"
      },
      {
        path: 'parametrage/comorbidite',
        loadChildren: './parametrage/comorbidite/categorie/categorie.module#CategorieModule'
      },
      {
        path: 'comorbidite',
        loadChildren: './comorbidite/comorbidites/comorbidites.module#ComorbiditesModule'
      }
    ]
  },
  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "parametrage/password",
    component: UpdatePasswordComponent
  },
  /* {
  path: '',
  component: AuthLayoutComponent,
  children: [{
    path: 'authentication',
    loadChildren: './authentication/authentication.module#AuthenticationModule'
  }, {
    path: 'error',
    loadChildren: './error/error.module#ErrorModule'
  }, {
    path: 'landing',
    loadChildren: './landing/landing.module#LandingModule'
  }, {
    path: 'maintenance/offline-ui',
    loadChildren: './maintenance/offline-ui/offline-ui.module#OfflineUiModule'
  }, ]
}, */
  {
    path: "**",
    redirectTo: "error/404"
  }
];



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/app.routing.ts